import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';

// Import all page components
import Home from './Pages/Home';
import Series from './Pages/Series';
import UkiesAdminSelections from './Pages/UkiesAdminSelections';
import Video from './Pages/Video';
import File from './Pages/File';
import NotFound from './Pages/NotFound';

// Import admin components
import UkiesAdmin from './Pages/UkiesAdmin';
import UkiesAdminSeries from './Pages/UkiesAdminSeries';
import UkiesAdminTesting from './Pages/UkiesAdminTesting';
import UkiesAdminFiles from './Pages/UkiesAdminFiles';
import UkiesAdminPages from './Pages/UkiesAdminPages';
import UkiesAdminPageDesigner from './Pages/UkiesAdminPageDesigner';

// Define the routes configuration
const routes = [
  { index: true, breadcrumb: 'Academy', element: <Home /> },
  { path: 'series', element: <Series /> },
  { path: 'series/video', element: <Video /> },
  { path: 'series/file', element: <File /> },
  { path: 'ukies-admin', element: <UkiesAdmin /> }, 
  { path: 'ukies-admin/series', element: <UkiesAdminSeries /> },
  { path: 'ukies-admin/testing', element: <UkiesAdminTesting /> },
  { path: 'ukies-admin/files', element: <UkiesAdminFiles /> },
  { path: 'ukies-admin/pages', element: <UkiesAdminPages /> },
  { path: 'ukies-admin/pages/:pageId', element: <UkiesAdminPageDesigner /> },
  { path: 'ukies-admin/selections', breadcrumb: 'Selecties', element: <UkiesAdminSelections /> },
  { path: '*', element: <NotFound /> },
]

const router = createBrowserRouter([
  {
    path: '/',
    element: <App routes={routes} />,
    children: routes,  // ← Only SOME routes become children
  },
]);

// Create root and render the app
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
    <RouterProvider router={router} />
  // </React.StrictMode>
);